import { variablesList } from '@models/system-variables/variables-to-insert';

function insertHtml(qtvar) {
	const template = qtvar ? `${qtvar}&nbsp;` : '';
	if (this.$editor()) {
		this.$editor().displayElements.text.trigger('focus');
		this.$editor().wrapSelection('inserthtml', template, true);
	}
}

function variablesAdapter(variableGroup, variableGroupName) {
	return Object.keys(variableGroup[variableGroupName]).reduce(
		(accum, key) =>
			`${accum} <li><a ng-click="insertVariable('${
				variableGroup[variableGroupName][key]
			}')">${key}</a></li>`,
		''
	);
}

function insertVariable(variable) {
	insertHtml.call(this, variable, true);
}

const fileUploadTemplate = `
	<div class="dropdown insert-var-container" unselectable="on" disabled="disabled">
		<button type="button" class="btn btn-default dropdown-toggle" name="attachment_fiels"
				tabindex="-1" on-click="executeAction($event)"
				ng-class="displayActiveToolClass(active)" data-toggle="dropdown" title="Attachment files"
				unselectable="on" disabled="disabled"><i class="fa fa-paperclip"></i>
		</button>
		<ul class="dropdown-menu no-overflow">
			<li><a class="showfiles" ng-click="showFilesModal()">From Files</a></li>
			<li><a ng-click="uploadFromComputer()">From Computer</a></li>	
		</ul>
	</div>
`;

const basicMenuTemplate = `
	<div class="dropdown insert-var-container" unselectable="on" disabled="disabled">
		<button class="btn btn-default dropdown-toggle" unselectable="on" ng-class="displayActiveToolClass(active)" on-click="executeAction($event)" tabindex="-1" data-toggle="dropdown">
			Insert variable<span class="caret"></span>
		</button>
		<ul class="dropdown-menu no-overflow">
			${variablesAdapter(variablesList, 'JOB_MENU')}
		</ul> 
	</div>
`;

const contractMenuTemplate = `
	<div class="dropdown insert-var-container" unselectable="on" disabled="disabled">
		<button class="btn btn-default dropdown-toggle" unselectable="on" ng-class="displayActiveToolClass(active)" on-click="executeAction($event)" tabindex="-1" data-toggle="dropdown">
			Insert variable<span class="caret"></span>
		</button>
		<ul class="dropdown-menu no-overflow">
			${variablesAdapter(variablesList, 'CONTRACT_MENU')}
		</ul> 
	</div>
`;

const invoiceMenuTemplate = `
	<div class="dropdown insert-var-container" unselectable="on" disabled="disabled">
		<button class="btn btn-default dropdown-toggle" unselectable="on" ng-class="displayActiveToolClass(active)" on-click="executeAction($event)" tabindex="-1" data-toggle="dropdown">
			Insert variable<span class="caret"></span>
		</button>
		<ul class="dropdown-menu no-overflow">
			${variablesAdapter(variablesList, 'INVOICE_MENU')}
		</ul> 
	</div>
`;

const calendarReminderMenuTemplate = `
	<div class="dropdown insert-var-container p-0" unselectable="on" disabled="disabled">
		<button class="btn btn-default dropdown-toggle" unselectable="on" ng-class="displayActiveToolClass(active)" data-toggle="dropdown" ng-mouseup="focusHack()">
			Insert variable<span class="caret"></span>
		</button>
		<ul class="dropdown-menu no-overflow">
			${variablesAdapter(variablesList, 'APPOINTMENT_REMINDER_MENU')}
		</ul>
	</div
`;

const clientOverviewEmailTemplate = `
	<div class="dropdown insert-var-container" unselectable="on" disabled="disabled">
		<button class="btn btn-default dropdown-toggle" unselectable="on" ng-class="displayActiveToolClass(active)" on-click="executeAction($event)" tabindex="-1" data-toggle="dropdown">
			Insert variable<span class="caret"></span>
		</button>
		<ul class="dropdown-menu no-overflow">
			${variablesAdapter(variablesList, 'CLIENT_MENU')}
		</ul>
	</div>
`;

export const fileUpload = {
	menu: fileUploadTemplate,
	methods: insertVariable
};

export const basicMenu = {
	menu: basicMenuTemplate,
	methods: insertVariable
};

export const contractMenu = {
	menu: contractMenuTemplate,
	methods: insertVariable
};

export const invoiceMenu = {
	menu: invoiceMenuTemplate,
	methods: insertVariable
};

export const calendarReminderMenu = {
	menu: calendarReminderMenuTemplate,
	methods: insertVariable
};

export const clientOverviewMailMenu = {
	menu: clientOverviewEmailTemplate,
	methods: insertVariable
};



// WEBPACK FOOTER //
// ./web/js/helper/rich_text_tokens.js